






















































































import { Vue, Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";

import { validationMixin } from "vuelidate";
import { required, between } from "vuelidate/lib/validators";
import { validTime, maxDate, minDate } from "@/mixins/DateValidators";

import { Select } from "@sureview/vuejs-sv-dropdown";
import DatePicker from "@sureview/vuejs-datepicker";

import { debounce } from "lodash";
import { CancelTokenSource } from "axios";

import api from "@/services/api.service";
import deviceSearchMixin from "@/components/video-reporting/deviceSearchMixin";
import { DeviceSearchResult } from "@/store/devices/types";
import { DeviceSearchModel } from "@/store/video-reporting/types";

const VideoReportingStore = namespace("videoReporting");

@Component({
	components: {
		"sv-select": Select,
		"date-picker": DatePicker
	},
	validations: {
		searchRequest: {
			deviceId: {
				required
			},
			date: {
				required,
				minDate: minDate(new Date(2016, 1, 1)), // Arbitrary minimum date
				maxDate: maxDate(new Date().setHours(23, 59, 59))
			},
			time: {
				required,
				validTime
			}
		}
	}
})
export default class SingleDeviceSearch extends Mixins(deviceSearchMixin, validationMixin) {
	@Prop({ type: Boolean, default: false }) private disabled: boolean;

	@VideoReportingStore.Getter("getMaxDurationPref") private maxDurationLimit: number;

	private searchRequest: DeviceSearchModel = {
		deviceId: null,
		deviceTypeId: null,
		title: null,
		date: null,
		time: null
	};

	@Watch("$v.$invalid")
	public onValidationStateChanged(newVal) {
		this.$emit("input", newVal ? null : [this.searchRequest]);
	}

	public onDeviceSelected(device: DeviceSearchResult) {
		let { deviceId, deviceTypeId, title } = device;

		this.searchRequest = {
			...this.searchRequest,
			deviceId,
			deviceTypeId,
			title
		};
	}
}
